module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-box"
  }, [_c('div', {
    staticClass: "plugin-arrow-overview",
    class: [_vm.flag ? 'plugin-arrow-overview' : 'top-arrow-overview'],
    on: {
      "click": _vm.hiddenLegend
    }
  }), _vm._v(" "), _c('div', {
    ref: "overviewContainer",
    staticClass: "overview-container"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6059fcc8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/overviewMap.vue
// module id = 84
// module chunks = 0